import { Fragment } from 'react'

export const Sample = () => {
    return <Fragment />
}
